import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { useIsBreakpointSize } from 'app/shared/utils';
import { AuthContext } from 'app/shared/context/Auth';
import { Image } from 'app/shared/components/atoms';
import { Box, Typography } from 'app/shared/components/atoms';
import { EVENT_PAGE_NEWSLETTER_IMAGE } from 'app/fan/utils/staticImages';
import { ValuePropWithDescription } from 'app/fan/components/molecules';
import { NewsletterForm } from 'app/fan/components/organisms';
import { FullWidthColumn } from 'app/fan/components/templates/BasePageGrid';

export const EventPageNewsletterForm = () => {
  const { loggedIn } = useContext(AuthContext);
  const { colors } = useCurrentTheme();
  const { formatMessage } = useIntl();
  const { isDesktop } = useIsBreakpointSize();

  // TODO: If user is logged in but opted out of marketing emails, show the form and have it update profile instead of creating a lead
  if (loggedIn) {
    return null;
  }

  return (
    <FullWidthColumn
      flexWrap="wrap-reverse"
      alignItems="flex-end" // because of wrap-reverse, this aligns the image to the TOP on large screens
      gap={10}
      justifyContent="space-between"
    >
      <Box
        flexDirection="column"
        gap={12}
        maxWidth={isDesktop ? '405px' : '100%'}
        minWidth={isDesktop ? '346px' : '100%'}
        flex="1 1 40%"
      >
        <Box flexDirection="column" gap={8}>
          <Typography
            fontFamily="title"
            fontSize="fontSize500"
            color={colors.primary.white.base}
            lineHeight="120%"
            as="h4"
          >
            {formatMessage({ id: 'event.newsletterForm.title' })}
          </Typography>
          <ValuePropWithDescription
            titleId="whatToExpect.intimateConcertsTitle"
            descriptionId="whatToExpect.intimateConcertsDescription"
            data-qaid="event-page-newsletter-form-value-prop-0"
          />
          <ValuePropWithDescription
            titleId="whatToExpect.unexpectedVenuesTitle"
            descriptionId="whatToExpect.unexpectedVenuesDescription"
            data-qaid="event-page-newsletter-form-value-prop-1"
          />
          <ValuePropWithDescription
            titleId="whatToExpect.limitlessVibesTitle"
            descriptionId="whatToExpect.limitlessVibesDescription"
            data-qaid="event-page-newsletter-form-value-prop-2"
          />
        </Box>
        <NewsletterForm
          withCitySelector={false}
          ctaText={formatMessage({ id: 'newsletter.joinNow' })}
          useTwoColumnLayout={true}
          formContext="event-page-newsletter-form"
        />
      </Box>
      <Box flex="1 1 50%">
        <Image
          src={EVENT_PAGE_NEWSLETTER_IMAGE[0]}
          srcMobile={EVENT_PAGE_NEWSLETTER_IMAGE[0]}
          srcTablet={EVENT_PAGE_NEWSLETTER_IMAGE[1]}
          srcSmallDesktop={EVENT_PAGE_NEWSLETTER_IMAGE[2]}
          srcLargeDesktop={EVENT_PAGE_NEWSLETTER_IMAGE[3]}
          w="100%"
          display="flex"
        />
      </Box>
    </FullWidthColumn>
  );
};
